export enum BackOfficeEvent {
    CloseModal = 'closeModal'
}



// WEBPACK FOOTER //
// ./src/backoffice/components/common/BackOfficeEvents.ts